import module from './index'

let moduleName = 'module->' + module.info.name;
const routes = [
  {
    path: module.info.name,
    name: moduleName,
    component: () => import('./View.vue'),
    children: [
      {
        path: 'lcr-panel',
        name: moduleName + '->lcr-panel',
        component: () => import('./lcr-panel/View'),
        children: [
          {
            path: ':tabName',
            name: moduleName + '->lcr-panel->tab',
            component: () => import('./lcr-panel/tabs/View.vue'),
          }
        ]
      },
    ]
  }
];

export default routes
